import { lazyWrap } from '@neptune/shared/common-ui';

export const LazyProjectEntryPoint = lazyWrap(
  async () =>
    (await import(/* webpackChunkName: "project" */ './ProjectEntryPoint')).ProjectEntryPoint,
);
